import HomePage from "../../pages/HomePage";
import Contact from "../../pages/Contact";
import Services from "../../pages/Services";

export const MenuItems = [
   {
      title: 'Home',
      url: '/',
      cName: 'nav-links'
    },
    {
        title: 'Services',
        url: '/Services',
        cName: 'nav-links'
    },
    {
        title: 'Products',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Contact Us',
        url: '/Contact',
        cName: 'nav-links'
    },
    {
        title: 'Login',
        url: '/Login',
        cName: 'nav-links-mobile'
    },
    {
        title: 'Sign-up',
        url: '/SignUp',
        cName: 'nav-links-mobile'
    }
  

]
